import './i18n/i18n';
import React from 'react';
import * as ReactDOM from 'react-dom/client';

import App from './app/app';
import createStore, { Environment } from './helpers/create-store';
import { ErrorBoundary } from './features/error-page';
import { StoreProvider } from './helpers/store-provider';
import Clarity from '@microsoft/clarity';

const reactEnv = import.meta.env.VITE_APP_ENV || 'development';
const clarotyProjectId =
  import.meta.env.VITE_CLAROTY_PROJECT_ID || 'development';

const initApp = async () => {
  let envConfig: Environment;

  try {
    envConfig = await fetch(`/env/${reactEnv}.json`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    }).then((res) => res.json());
  } catch {
    try {
      envConfig = await fetch(`/env/development.json`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then((res) => res.json());
    } catch (e) {
      console.error('Error fetching configuration:', e);
      return;
    }
  }

  const { rootStore } = createStore({ envConfig });

  // Save initial URL before React Router processes it
  // This must happen before rendering to capture the original URL
  rootStore.uiStore.saveRedirectUrl();

  const rootElement = document.getElementById('root');

  if (!rootElement) {
    console.warn(`Root element not found`);
    return;
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  if (clarotyProjectId) {
    Clarity.init(clarotyProjectId);
  }

  root.render(
    <ErrorBoundary>
      <StoreProvider value={rootStore}>
        <App />
      </StoreProvider>
    </ErrorBoundary>
  );
};

initApp();
